import { render, staticRenderFns } from "./BootstrapSwitch.vue?vue&type=template&id=7d5a7350"
import script from "./BootstrapSwitch.vue?vue&type=script&lang=js"
export * from "./BootstrapSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports